(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    class HapticBtn extends HTMLElement {
    connectedCallback() {
      const preset = this.dataset.haptic ?? 'success';
      this.addEventListener('click', () => window.haptics?.trigger(preset), { passive: true });
    }
  }

  customElements.define('haptic-btn', HapticBtn);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-popup"] && !Shopify.designMode) return;
  try {
    class LocalizationPopup extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'ankon_localization_popup_dismissed';
      this.dialog = this.querySelector('dialog');
      this.dismissBtn = this.querySelector('[data-dismiss]');
      this.redirectLink = this.querySelector('[data-redirect-link]');
      this.currentLanguage = this.dataset.currentLanguage;
      this.danishUrl = this.dataset.danishUrl;
      this.englishUrl = this.dataset.englishUrl;
    }

    connectedCallback() {
      if (this.hasBeenDismissed()) return;
      this.detectAndShow();
    }

    hasBeenDismissed() {
      try {
        return localStorage.getItem(this.storageKey) === 'true';
      } catch (e) {
        return false;
      }
    }

    setDismissed() {
      try {
        localStorage.setItem(this.storageKey, 'true');
      } catch (e) {}
    }

    async detectAndShow() {
      const detectedCountry = await this.detectCountry();
      if (!detectedCountry) return;

      const isDanishVisitor = detectedCountry === 'DK';
      const isOnEnglishMarket = this.currentLanguage === 'en';
      const isOnDanishMarket = this.currentLanguage === 'da';

      if (isDanishVisitor && isOnEnglishMarket) {
        this.showPopup('danish');
      } else if (!isDanishVisitor && isOnDanishMarket) {
        this.showPopup('english');
      }
    }

    async detectCountry() {
      try {
        const response = await fetch(
          window.Shopify.routes.root +
          'browsing_context_suggestions.json' +
          '?country[enabled]=true'
        );
        const data = await response.json();
        return data.detected_values?.country?.handle || null;
      } catch (e) {
        return null;
      }
    }

    showPopup(variant) {
      const messageDanish = this.querySelector('[data-message-danish]');
      const messageEnglish = this.querySelector('[data-message-english]');

      if (variant === 'danish') {
        messageDanish.hidden = false;
        messageEnglish.hidden = true;
        this.redirectLink.href = this.danishUrl;
      } else {
        messageDanish.hidden = true;
        messageEnglish.hidden = false;
        this.redirectLink.href = this.englishUrl;
      }

      this.dialog.show();
      this.bindEvents();
    }

    bindEvents() {
      this.dismissBtn.addEventListener('click', () => this.dismiss());
      this.redirectLink.addEventListener('click', () => this.setDismissed());
    }

    dismiss() {
      this.setDismissed();
      this.dialog.close();
    }
  }

  customElements.define('localization-popup', LocalizationPopup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scripts"] && !Shopify.designMode) return;
  try {
    // sets object-fit on lottie animations after some time. 
  // timeout is irrelevant due to this style only being needed on window resizes
  // to prevent weird scalings.
  setTimeout(() => {
    [...document.querySelectorAll("dotlottie-wc")].forEach(item => {
      console.log('item', item);
      item.shadowRoot.querySelector("canvas")?.setAttribute("style", "object-fit: cover");
    });
  }, 1500);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["terminal"] && !Shopify.designMode) return;
  try {
    class AnkonTerminal extends HTMLElement {
    connectedCallback() {
      this.prompt = this.dataset.prompt || 'ankon@shopify ~ $';
      this.body = this.querySelector('.terminal__body');
      this.output = this.querySelector('.terminal__output');
      this.inputLine = this.querySelector('.terminal__input-line');
      this.input = this.querySelector('.terminal__input');

      this.commands = {};
      this.hiddenCommands = new Set();
      this.querySelectorAll('.terminal__registry [data-name]').forEach((el) => {
        this.commands[el.dataset.name] = el.textContent;
        if (el.hasAttribute('data-hidden')) this.hiddenCommands.add(el.dataset.name);
      });

      this.ready = false;

      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.addEventListener('click', (e) => {
        if (!this.ready) return;
        if (e.target.closest('.terminal__chrome')) return;
        if (e.target === this.input) return;
        this.focusInput();
      });

      requestAnimationFrame(() => this.init());
    }

    init() {
      // Lock body height to the pre-rendered content size so user-typed
      // commands scroll inside instead of pushing the page layout around.
      this.body.style.height = this.body.scrollHeight + 'px';

      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const designMode = window.Shopify && window.Shopify.designMode;
      if (reduce || designMode) {
        this.enableInput();
        return;
      }

      // Typewriter: detach pre-rendered lines and re-type them.
      const lines = [...this.output.children].filter((c) => c !== this.inputLine);
      lines.forEach((line) => line.remove());
      this.inputLine.hidden = true;

      this.typeIntro(lines).then(() => {
        this.inputLine.hidden = false;
        this.enableInput();
      });
    }

    enableInput() {
      this.input.setAttribute('contenteditable', 'true');
      this.ready = true;
    }

    async typeIntro(lines) {
      for (const line of lines) {
        await this.typeLine(line);
        const isCommand = !!line.querySelector('.terminal__command');
        await this.sleep(isCommand ? 150 : 60);
      }
    }

    async typeLine(lineEl) {
      const textNodes = this.collectTextNodes(lineEl);
      const originals = textNodes.map((n) => n.textContent);
      textNodes.forEach((n) => (n.textContent = ''));
      this.append(lineEl);
      this.scrollBottom();

      for (let i = 0; i < textNodes.length; i++) {
        const node = textNodes[i];
        const full = originals[i];
        for (let j = 1; j <= full.length; j++) {
          node.textContent = full.slice(0, j);
          await this.sleep(this.charDelay());
        }
        this.scrollBottom();
      }
    }

    collectTextNodes(el) {
      const nodes = [];
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) nodes.push(walker.currentNode);
      return nodes;
    }

    charDelay() {
      // 8–18ms, a little jitter to feel less robotic
      return 4 + Math.random() * 10;
    }

    sleep(ms) {
      return new Promise((r) => setTimeout(r, ms));
    }

    focusInput() {
      this.input.focus({ preventScroll: true });
      const range = document.createRange();
      range.selectNodeContents(this.input);
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }

    onKey(e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      if (!this.ready) return;
      const raw = this.input.textContent.trim();
      this.input.textContent = '';
      if (!raw) return;
      this.run(raw);
    }

    async run(cmd) {
      this.ready = false;
      this.input.setAttribute('contenteditable', 'false');

      if (cmd === 'clear') {
        this.clearOutput();
      } else {
        this.append(this.buildCommandLine(cmd));
        this.scrollBottom();
        await this.sleep(150);

        let response;
        if (cmd === 'help') {
          response = this.buildHelp();
        } else if (Object.prototype.hasOwnProperty.call(this.commands, cmd)) {
          response = this.commands[cmd];
        } else {
          response = `command not found: ${cmd}. try "help".`;
        }
        await this.typeResponse(response);
      }

      this.input.setAttribute('contenteditable', 'true');
      this.ready = true;
      this.focusInput();
    }

    clearOutput() {
      [...this.output.children].forEach((child) => {
        if (child !== this.inputLine) child.remove();
      });
      this.scrollBottom();
    }

    async typeResponse(text) {
      const lines = text.split('\n');
      for (const raw of lines) {
        const line = raw.trim();
        if (!line) continue;
        await this.typeLine(this.buildResponseLine(line));
        await this.sleep(60);
      }
    }

    buildHelp() {
      const names = Object.keys(this.commands).filter((n) => !this.hiddenCommands.has(n));
      const has = (n) =>
        Object.prototype.hasOwnProperty.call(this.commands, n) && !this.hiddenCommands.has(n);

      // Collect subcommand args grouped by their parent command.
      const argsByParent = new Map();
      names.forEach((n) => {
        const parts = n.split(/\s+/);
        if (parts.length < 2) return;
        const base = parts[0];
        if (!has(base)) return;
        if (!argsByParent.has(base)) argsByParent.set(base, []);
        argsByParent.get(base).push(parts.slice(1).join(' '));
      });

      const lines = [];
      names.forEach((n) => {
        const parts = n.split(/\s+/);
        const base = parts[0];
        const isSubcommand = parts.length > 1 && has(base);
        if (isSubcommand) return;
        if (argsByParent.has(base)) {
          const args = argsByParent.get(base);
          const max = 3;
          const shown = args.slice(0, max);
          if (args.length > max) shown.push('…');
          lines.push(`${base} [${shown.join('|')}]`);
        } else {
          lines.push(n);
        }
      });

      const all = [...lines, 'help', 'clear'].map((line) => '› ' + line);
      if (argsByParent.size > 0) all.push('› tip: run a command alone for details');
      return all.join('\n');
    }

    buildCommandLine(cmd) {
      const row = document.createElement('div');
      row.append(
        this.span('terminal__prompt', this.prompt),
        document.createTextNode(' '),
        this.span('terminal__command', cmd)
      );
      return row;
    }

    buildResponseLine(line) {
      const row = document.createElement('div');
      const marker = line.charAt(0);
      const rest = line.slice(1).trim();

      switch (marker) {
        case '$':
          row.append(
            this.span('terminal__prompt', this.prompt),
            document.createTextNode(' '),
            this.span('terminal__command', rest)
          );
          break;
        case '✓':
          row.append(this.span('terminal__ok', '✓'), document.createTextNode(' ' + rest));
          break;
        case '›':
          row.append(this.span('terminal__muted', '›'), document.createTextNode(' ' + rest));
          break;
        case '●':
          row.append(this.span('terminal__status-dot', '●'), document.createTextNode(' ' + rest));
          break;
        default:
          row.textContent = line;
      }
      return row;
    }

    span(className, text) {
      const s = document.createElement('span');
      s.className = className;
      s.textContent = text;
      return s;
    }

    append(node) {
      this.inputLine.before(node);
    }

    scrollBottom() {
      this.body.scrollTop = this.body.scrollHeight;
    }
  }

  customElements.define('ankon-terminal', AnkonTerminal);
  } catch(e) { console.error(e); }
})();

})();
